/** When your routing table is too long, you can split it into small modules**/
import ConstructionHome from  '@/components/ConstructionHome'
import ContentSite from '@/components/ContentSite'
/*
import projectReportList from '@/views/constructionUnit/projectReport/list'
import projectQueryList from '@/views/constructionUnit/projectQuery/list'
import taskShowConfirm from '@/views/constructionUnit/task/showConfirm'
import taskBack from '@/views/constructionUnit/task/back'
import ticketOpeningList from '@/views/constructionUnit/ticketOpening/list'
/!*import contractStatisticsList from '@/views/constructionUnit/contractStatistics/list'*!/
import contractTemplateList from '@/views/constructionUnit/contractTemplate/list'
import projectChangeList from '@/views/constructionUnit/projectChange/list'
import projectQuerydetails from '@/views/constructionUnit/projectQuery/details'
import projectQueryProcedure from '@/views/constructionUnit/projectQuery/procedure'
import projectQueryMaterial from '@/views/constructionUnit/projectQuery/materialManager'
import constructionRegister from '@/views/constructionUnit/user/register'
import constructionUserInfo from '@/views/constructionUnit/user/info'
import addMaterial from '@/views/constructionUnit/projectReport/addMaterial'
*/

const censor = {
  path: '/constructionHome',
  name: '建设单位',
  meta: {construction : true,title:'建设单位'},
  redirect:{path:'/constructionHome/HOME/censor'},
  component: ConstructionHome,
  children: [
  		{
      path: 'HOME/:type',
      component: () => import('@/views/inspectDraw/business/configuration/home'),
      name: 'censorHOME',
      meta: {title : 'HOME'},
      hidden:true
    },
		{
			path: 'constructionUnit',
			component: ContentSite,
			name: 'formReportList11222',
			meta: {title : '项目报审',roles:'constructioncorpemployee'},
				children: [
				// {
				// 	path: 'formReport',
				// 	component: () => import('@/views/constructionUnit/formReport/list'),
				// 	name: 'projectReportList2',
				// 	meta: {title : '勘察工程',roles:'constructioncorpemployee'},
				// },
				// {
				// 	path: 'formReport',
				// 	component: () => import('@/views/constructionUnit/formReport/list'),
				// 	name: 'projectReportList2',
				// 	meta: {title : '勘察工程'},
				// },
				// {
				// 	path: 'formReport',
				// 	component: () => import('@/views/constructionUnit/formReport/list'),
				// 	name: 'projectReportList2',
				// 	meta: {title : '勘察工程'},
				// },
				{
					path: 'engineeringConstraction',
					component: ContentSite,
					name: 'projectReportList4',
					meta: {title : '房建工程',roles:'constructioncorpemployee'},
          children: [
            {
              path: 'survey',
              component: () => import('@/views/constructionUnit/engineeringConstraction/survey'),
              name: 'projectReportList5',
              meta: {title : '建筑勘察',roles:'constructioncorpemployee'},
            },
            {
              path: 'design',
              component: () => import('@/views/constructionUnit/engineeringConstraction/design'),
              name: 'projectReportList6',
              meta: {title : '建筑设计',roles:'constructioncorpemployee'},
            }
          ]
				},
				{
					path: 'engineeringCity',
					meta: {title : '市政工程',roles:'constructioncorpemployee'},
					name: 'engineeringCity',
					component: ContentSite,
          children: [
            {
              path: 'survey',
              component: () => import('@/views/constructionUnit/engineeringCity/survey'),
              name: 'survey',
              meta: {title : '市政勘察',roles:'constructioncorpemployee'},
            },
            {
              path: 'design',
              component: () => import('@/views/constructionUnit/engineeringCity/design'),
              name: 'design',
              meta: {title : '市政设计',roles:'constructioncorpemployee'},
            }
          ]
				},
				// {
				// 	path: 'engineeringDesign',
				// 	component: () => import('@/views/constructionUnit/engineeringDesign/list'),
				// 	name: 'projectReportList9',
				// 	meta: {title : '设计单位'},
				// },
				{
					path: 'engineeringSpecial',
					component: ContentSite,
					name: 'projectReportList10',
          meta: {title : '专项工程',roles:'constructioncorpemployee'},
						children: [
              // {
              //   path: 'engineeringDitch',
              //   component: () => import('@/views/constructionUnit/engineeringDitch/list'),
              //   name: 'engineeringDitch',
              //   meta: {title : '基坑工程',roles:'constructioncorpemployee'},
              // },
							{
								path: 'muqiangDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/muqiangDesign'),
								name: 'muqiangDesign',
								meta: {title : '幕墙工程',roles:'constructioncorpemployee'},
              },
              {
								path: 'menchuangDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/menchuangDesign'),
								name: 'menchuangDesign',
								meta: {title : '门窗工程',roles:'constructioncorpemployee'},
              },
							{
								path: 'qinggangDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/qinggangDesign'),
								name: 'qinggangDesign',
								meta: {title : '轻钢工程',roles:'constructioncorpemployee'},
              },
              {
								path: 'zhuangshiDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/zhuangshiDesign'),
								name: 'zhuangshiDesign',
								meta: {title : '装饰装修',roles:'constructioncorpemployee'},
              },
              {
								path: 'jianzhuDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/jianzhuDesign'),
								name: 'jianzhuDesign',
								meta: {title : '建筑智能化系统',roles:'constructioncorpemployee'},
              },
              {
								path: 'xiaofangDesign',
								component: () => import('@/views/constructionUnit/engineeringSpecial/xiaofangDesign'),
								name: 'xiaofangDesign',
								meta: {title : '消防专项审查(除房建市政工程)',roles:'constructioncorpemployee'},
							},
              //  {
							// 	path: 'zhuanjiahuishenDesign',
							// 	component: () => import('@/views/constructionUnit/engineeringSpecial/zhuanjiahuishenDesign'),
							// 	name: 'zhuanjiahuishenDesign',
							// 	meta: {title : '设计—专家会审工程',roles:'constructioncorpemployee'},
							// },
						]
				},
			]
		},
   /* {
      path: 'constructionUnit/projectReport',
      component: () => import('@/views/constructionUnit/projectReport/list'),
      name: 'projectReportList',
      meta: {title : '项目报审',roles:'constructioncorpemployee'},
    },*/
    {
      path: 'constructionUnit/projectQueryList',
      component: () => import('@/views/constructionUnit/projectQuery/list'),
      name: 'projectQueryList',
      meta: {
        title : '项目查询',
        roles:'constructioncorpemployee',
        keepAlive:true,
        keepCount:true
      },
    },
    {
      path: 'constructionUnit/taskVerify',
      component: () => import('@/views/constructionUnit/task/verify'),
      name: 'taskVerify',
      meta: {title : '报审确认',roles:'constructioncorpemployee'},
    },
  /*  {
      path: 'constructionUnit/constructionUnitUserManager',
      component: () => import('@/views/constructionUnit/userManager/list'),
      name: 'constructionUnitUserManager',
      meta: {title : '员工管理',roles:'manager'},
    },*/
  /*  {
      path: 'constructionUnit/constructionUnitAllot',
      component: () => import('@/views/constructionUnit/task/allot'),
      name: 'constructionUnitAllot',
      meta: {title : '项目分配',roles:'manager'},
    },*/
    {
      path: 'constructionUnit/taskBack',
      component: () => import('@/views/constructionUnit/task/back'),
      name: 'taskBack',
      meta: {title : '【审图机构】项目退回',roles:'constructioncorpemployee'},
    },
    {
      path: 'constructionUnit/taskDrawing',
      component: () => import('@/views/constructionUnit/task/drawing'),
      name: 'taskDrawing',
      meta: {title : '【勘察设计单位】图纸退回',roles:'constructioncorpemployee'},
    },
    {
      path: 'constructionUnit/taskWaitReplyConfirm',
      component: () => import('@/views/constructionUnit/task/waitReplyConfirm'),
      name: 'taskWaitReplyConfirm',
      meta: {title : '【审图机构】意见确认',roles:'constructioncorpemployee'},
    },
    {
      path: 'constructionUnit/taskShowConfirm',
      component: () => import('@/views/constructionUnit/task/showConfirm'),
      name: 'taskShowConfirm',
      meta: {title : '【勘察设计单位】回复确认',roles:'constructioncorpemployee'},
    },
    {
      path: 'constructionUnit/ticketOpeningList',
      component: () => import('@/views/constructionUnit/ticketOpening/list'),
      name: 'ticketOpeningList',
      meta: {title : '开票维护',roles:'manager'},
    },
    // {
    //   path: 'constructionUnit/signature',
    //   component: () => import('@/views/common/task/censor_compact'),
    //   name: 'ticketSignature',
    //   meta: {title : '合同管理',roles:'constructioncorpemployee'},
    // },
    /* {
       path: 'constructionUnit/contractStatisticsList',
       component: contractStatisticsList,
       name: 'contractStatisticsList',
       meta: {title : '项目合同查询统计'},
     },*/
    // {
    //   path: 'constructionUnit/contractTemplateList',
    //   component: () => import('@/views/constructionUnit/contractTemplate/list'),
    //   name: 'contractTemplateList',
    //   meta: {title : '合同查询',roles:'constructioncorpemployee'},
    // },
    {
      path: 'constructionUnit/projectChangeList',
      component: () => import('@/views/constructionUnit/projectChange/list'),
      name: 'projectChangeList',
      meta: {title : '项目变更',roles:'constructioncorpemployee'},
    },
    // {
    //   path: 'constructionUnit/filelist',
    //   component: () => import('@/views/common/task/filelist'),
    //   name: 'projectfilelist',
    //   meta: {title : '项目归档',roles:'constructioncorpemployee'},
    // },
    {
      path: 'constructionUnit/projectQuery/projectQuerydetails',
      component: () => import('@/views/constructionUnit/projectQuery/details'),
      name: 'projectQuerydetails',
      meta: {title : '详情',roles:'constructioncorpemployee'},
      hidden: true,
    },
    {
      path: 'constructionUnit/projectQuery/projectQuerydetail',
      component: () => import('@/views/constructionUnit/projectQuery/detail'),
      name: 'projectQuerydetail',
      meta: {title : '详情',roles:'constructioncorpemployee'},
      hidden: true,
    },{
      path: 'constructionUnit/projectQuery/projectQueryProcedure',
      component: () => import('@/views/constructionUnit/projectQuery/procedure'),
      name: 'projectQueryProcedure',
      meta: {title : '流程',roles:'constructioncorpemployee'},
      hidden: true,
    },{
      path: 'constructionUnit/projectReport/addMaterial',
      component: () => import('@/views/constructionUnit/projectReport/addMaterial'),
      name: 'addMaterial',
      hidden: true,
    },{
      path: 'constructionUnit/projectQuery/projectQueryMaterial',
      component: () => import('@/views/constructionUnit/projectQuery/materialManager'),
      name: 'projectQueryMaterial',
      meta: {title : '维护',roles:'constructioncorpemployee'},
      hidden: true,
    },{
      path: 'constructionUnit/constructionUserInfo',
      component: () => import('@/views/constructionUnit/user/info'),
      name: 'constructionUserInfo',
      meta: {title : '信息维护',roles:'manager'},
    },{
      path: '/constructionUnit/taskInMessage',
      component: () => import('@/views/inspectDraw/business/task/inMessage'),
      name: 'conInMessage',
    	meta: {title : '内部消息',roles:'constructioncorpemployee'},
      hidden: true,
    },{
      path: '/constructionUnit/editTask',
      component: () => import('@/views/constructionUnit/reportExamine/editTask'),
      name: 'UniteditTask',
      meta: {title : '接审确认'},
      hidden: true,
    },
    {
      path: '/constructionUnit/submitConfirm',
      component: () => import('@/views/constructionUnit/reportExamine/submitConfirm'),
      name: 'submitConfirm',
      meta: {title : '接审确认'},
      hidden: true,
    }
  ]
};

export default censor



// WEBPACK FOOTER //
// ./src/router/censor/index.js